// Venice.ai supported LLM chat models
export type VeniceLlmModel =
  | 'deepseek-v4-pro'
  | 'grok-4-3'
  | 'llama-3.3-70b';

export interface VeniceLlmModelInfo {
  id: VeniceLlmModel;
  name: string;
  description: string;
  cost: number; // cost in credits (1 credit = $0.02)
  messagesPerCredit: number; // number of AI responses per credit charge
}

// Model costs in credits (1 credit = $0.02)
// These are fallback values; production should fetch from model_pricing table
export const VENICE_LLM_MODELS: VeniceLlmModelInfo[] = [
  {
    id: 'deepseek-v4-pro',
    name: 'DeepSeek V4 Pro',
    description: 'Top-tier reasoning & chain-of-thought — recommended for deeper study',
    cost: 2,
    messagesPerCredit: 3,
  },
  {
    id: 'grok-4-3',
    name: 'Grok 4.3',
    description: "xAI's latest — strong reasoning with a direct, candid style",
    cost: 2,
    messagesPerCredit: 3,
  },
  {
    id: 'llama-3.3-70b',
    name: 'Llama 3.3 70B',
    description: 'Fast, balanced responses — great for quick questions',
    cost: 1,
    messagesPerCredit: 5,
  },
];

export const DEFAULT_LLM_MODEL: VeniceLlmModel = 'deepseek-v4-pro';

/** Type guard for a known, currently-offered model id. */
export function isValidLlmModel(
  model: string | null | undefined
): model is VeniceLlmModel {
  return !!model && VENICE_LLM_MODELS.some((m) => m.id === model);
}

export function getLlmModelInfo(model: VeniceLlmModel): VeniceLlmModelInfo {
  // Fall back to the default model's info if an unknown id slips through (e.g. a
  // removed model still stored in a user's localStorage), so callers never get
  // undefined.
  return (
    VENICE_LLM_MODELS.find((m) => m.id === model) ??
    VENICE_LLM_MODELS.find((m) => m.id === DEFAULT_LLM_MODEL)!
  );
}
